import React from 'react';
import { useSelector } from 'react-redux';

import Header from '../../components/Header';
import Title from '../../components/Title';
import Text from '../../components/Text';
import Line from '../../components/Line';
import Actions from '../../components/Actions';
import Card from './Card';
import MobileMenuHeader from '../../components/MobileMenuHeader';

export default function Summary(props) {
  const {
    nextClickHandler,
    menuItems,
    selectComponent,
    componentIndex,
    rules,
    backPath,
    locales,
    locales: {
      common,
      tipCustomerSegment,
      revenue: {
        name,
        summary: { header, title, text },
        intro: { card },
      },
    },
  } = props;
  const { revenue, product } = useSelector((state) => state);

  return (
    <section className="bmc-page" aria-label={header}>
      <Header
        title={header}
        subtitle={name}
        icon="icon-revenue"
        locales={locales}
        componentIndex={componentIndex}
        className="bmc-page-header--violet"
        tipLocales={tipCustomerSegment}
        menuItems={menuItems}
        onMenuItemClick={selectComponent}
        rules={rules}
        backPath={backPath}
        mobileMenuHeader={
          <MobileMenuHeader icon="FinanceCanvas" title={name} color="violet" />
        }
      />

      <Text>{[text[0]]}</Text>

      <Line />

      <Title text={title[0]} className="margin-top-60" />

      <Card
        card={{
          ...card,
          title: false,
          revenues: revenue.collection,
          products: product.collection,
        }}
        className="margin-top-60 margin-wide-40-lg"
        locales={locales}
        forecast
      />

      <Actions nextClickHandler={nextClickHandler} buttonName={common.done} />
    </section>
  );
}
